<script>
import {product as columns} from "../../tables"

export default {
  data() {
    return {
      columns,
      form: this.$form.createForm(this),
      loading: false,
      expand: false,
      items: {},
      filters: {
        q: null,
        page: 1,
        per_page: 10,
        groups: []
      },
      stateChanging: []
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  computed: {
    pageSize() {
      return parseInt(this.items.per_page)
    }
  },
  methods: {
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.pushState(this.filters)
      this.getItems()
    },
    handleAutocomplete(v, iteratee) {
      if (v.length === 0) {
        this.filters[iteratee] = []
      } else {
        this.filters[iteratee] = _.map(v, (o) => o.id)
      }
    },
    handleReset(e) {
      e.preventDefault()
      this.filters = {
        q: null,
        page: 1,
        groups: []
      }
    },
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product'), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    toggleState(record) {
      this.stateChanging.push(record.hash)
      this.$http.patch(this.routeUri('hyperion.product.patch',  { product_hash: record.hash}), {
        action: 'TOGGLE_STATE'
      })
        .then(() => this.onSuccessChangingState(record))
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.onFinishedChangingState(record))
    },
    onSuccessChangingState(record) {
      let index = this.items.data.findIndex(i => i.hash === record.hash)
      if (index > -1) {
        this.items.data[index].is_active = !record.is_active
      }
    },
    onFinishedChangingState(record) {
      let index = this.stateChanging.indexOf(record.hash)
      if (index > -1) {
        this.stateChanging.splice(index, 1)
      }
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="24" class="form-filter-wrapper" :class="expand ? 'expanded' : ''">
        <a-col :span="6">
          <a-input placeholder="Keyword.." v-model="filters.q">
            <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-col>
        <a-col :span="6">
          <group-autocomplete style="width: 100%" @change="(item) => handleAutocomplete(item, 'groups') "/>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" class="text-right">
          <a-button type="primary" html-type="submit" icon="filter"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Filter
          </a-button>
          <a-button class="ml-2" type="dashed" html-type="reset" icon="reload" @click="handleReset"
                    :style="{ display: expand ? 'inline-block' : 'none'}">Reset
          </a-button>

          <a class="ml-2" @click="() => this.expand = !this.expand ">Filter <a-icon :type="expand ? 'up' : 'down'"/></a>
        </a-col>
      </a-row>
    </a-form>

    <a-divider dashed/>

    <a-skeleton :loading="loading" active>
      <a-table :columns="columns" :dataSource="items.data" rowKey="hash"
               :pagination="{ pageSize: pageSize, current: items.current_page, total: items.total, showSizeChanger: true }"
               @change="tableChanged">

        <div slot="group" slot-scope="record">
          <a-button size="small" type="link" icon="tags"/>
          {{ record.group.name }}
        </div>

        <div slot="code" slot-scope="record">
          <h4>{{ record.code }} // <small>{{ record.name }}</small></h4>
        </div>

        <h4 slot="denomination" slot-scope="record">
          <currency :amount="record.denomination" />
        </h4>

        <h4 slot="price" slot-scope="record">
            <currency :amount="record.price" />
        </h4>

        <div slot="priceScheme" slot-scope="record">
          <strong><code>{{ record.price_scheme }}</code></strong>
        </div>

        <h4 slot="adminFee" slot-scope="record">
          <currency :amount="record.admin_fee" />
        </h4>

        <h4 slot="shareFee" slot-scope="record">
          <currency :amount="record.share_fee" />
        </h4>

        <p slot="updatedAt" slot-scope="updated_at" class="text-sm">
          <a-tooltip :title="moment(updated_at).format('YYYY-MM-DD HH:mm:ss')">
            {{ moment(updated_at).fromNow() }}
          </a-tooltip>
        </p>

        <div class="text-center" slot="state" slot-scope="record">
          <template v-if="stateChanging.includes(record.hash)">
            <a-tag style="margin-right: 0;">LOADING</a-tag>
          </template>
          <template v-else>
            <a-popconfirm title="Sure to disable product?" @confirm="() => toggleState(record)" v-if="record.is_active">
              <a-tag style="cursor:pointer; margin-right: 0;" color="#87d068">Active</a-tag>
            </a-popconfirm>
            <a-popconfirm title="Sure to enable product?" @confirm="() => toggleState(record)" v-else>
              <a-tag style="cursor:pointer; margin-right: 0" color="#f50">Inactive</a-tag>
            </a-popconfirm>
          </template>
        </div>

        <div slot="action" slot-scope="record">
          <a-tooltip title="Product Detail">
            <a-button size="small" icon="ellipsis"
                      :href="routeUri('hyperion.product.show', { product_hash: record.hash })"/>
          </a-tooltip>
        </div>
      </a-table>
    </a-skeleton>
  </a-card>
</template>
